import { FC } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

/**
 * 버튼 안에서 쓰는 소형 로딩 인디케이터.
 * 버튼 글자색(currentColor)을 그대로 따르는 링 스피너라 어떤 배경 버튼에서도 보인다.
 * 페이지/섹션 로딩은 LoadingSpinner(브랜드 워드마크)를 쓰고, 버튼 진행 상태는 문구 대신 이 컴포넌트로 통일한다.
 */

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Ring = styled.span`
    display: inline-block;
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    border: 0.15em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    opacity: 0.85;
    animation: ${spin} 0.7s linear infinite;
`;

const ButtonSpinner: FC = () => <Ring role="status" aria-label="처리 중" />;

export default ButtonSpinner;
